import PropTypes from 'prop-types'
import React from 'react'
import { injectIntl } from 'react-intl'
import { SubmissionError } from 'redux-form'
import { NOTE_CONTENT_MAX_LENGTH } from 'const/limits'
import {
  ContentBody
} from 'components/Content'
import KanBoIcon from 'components/KanBoIcon'
import getCharCount from 'components/RichText/utils/getCharCount'
import trimRichText from 'components/RichText/utils/trim'
import RichTextContent from 'components/RichText/Content'
import Element from '../Element'
import ElementInfo from '../ElementInfo'
import { withBoardPermission } from 'dataProviders/Board'

export class Note extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,

    permission: PropTypes.object.isRequired,

    isCardArchived: PropTypes.bool.isRequired,
    boardId: PropTypes.number.isRequired,
    content: PropTypes.object.isRequired,

    requestChangeNoteContent: PropTypes.func.isRequired,

    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    sortable: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)

    this.handleContentSubmit = this.handleContentSubmit.bind(this)
  }

  handleContentSubmit (content) {
    const {
      intl,
      id,
      requestChangeNoteContent
    } = this.props

    return new Promise((resolve) => {
      const contentCharCount = getCharCount(content)
      if (contentCharCount === 0) {
        throw new SubmissionError({ content: intl.formatMessage({ id: 'NOTE_EMPTY' }) })
      } else if (contentCharCount > NOTE_CONTENT_MAX_LENGTH) {
        throw new SubmissionError({ content: intl.formatMessage({ id: 'NOTE_TOO_LONG' }, { limit: NOTE_CONTENT_MAX_LENGTH }) })
      }

      requestChangeNoteContent({
        noteId: id,
        content: trimRichText(content)
      })

      resolve()
    })
  }

  render () {
    const {
      permission,
      isCardArchived,
      id,
      boardId,
      content,

      sortable
    } = this.props

    return (
      <Element
        id={id}
        icon={<KanBoIcon name='kanbo-24-note' />}
        collapsible
        sortable={sortable}
      >
        {(collapsed) => (
          <ContentBody>
            {collapsed &&
              <ElementInfo
                icon={<KanBoIcon name='kanbo-16-letter-count' />}
              >
                {getCharCount(content)}
              </ElementInfo>
            }
            {!collapsed &&
              <RichTextContent
                checklistBlockTypes
                content={content}
                mentionBoardId={boardId}
                saveChanges={'noteContentEdit-' + id}
                maxLength={NOTE_CONTENT_MAX_LENGTH}
                editable={!isCardArchived && permission.member}
                onSubmit={this.handleContentSubmit}
              />
            }
          </ContentBody>
        )}
      </Element>
    )
  }
}

export default injectIntl(withBoardPermission(Note), { forwardRef: true })
